import script from "./NewPasswordForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewPasswordForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__